export const errorCodes = {
  ECONNABORTED: 'ECONNABORTED',
};
